import { useState } from "react";
import RichTextEditor from "react-rte";
import "./complaintManagement.css";

const ComplaintRichTextEditor = ({
  value = "",
  onChange,
  placeholder = "",
  minHeight = 140,
  editorKey = 0,
}) => {
  const [editorValue, setEditorValue] = useState(() =>
    value
      ? RichTextEditor.createValueFromString(value, "html")
      : RichTextEditor.createEmptyValue()
  );

  const handleChange = (nextValue) => {
    setEditorValue(nextValue);
    onChange(nextValue.toString("html"));
  };

  return (
    <div
      key={editorKey}
      className="cmp-rich-text-editor"
      style={{ minHeight }}
    >
      <RichTextEditor
        value={editorValue}
        onChange={handleChange}
        placeholder={placeholder}
      />
    </div>
  );
};

export default ComplaintRichTextEditor;
